import { useState } from 'react';

import vizitProBanner from '@/assets/brand/banner.png';

import { ForgotPasswordForm } from './forgot-password-form';
import { type View } from './schema';
import { SignInForm } from './sign-in-form';
import { SignUpForm } from './sign-up-form';

export function Login() {
  const [view, setView] = useState<View>('sign-in');

  return (
    <div className="flex min-h-svh flex-col items-center justify-center gap-6 p-4">
      <div className="flex flex-col items-center gap-2">
        <div className="rounded-xl bg-white px-5 py-3">
          <img src={vizitProBanner} alt="VizitPro" className="h-16 w-auto sm:h-20" />
        </div>
        <span className="text-muted-foreground text-sm">
          Run your service business, simplified.
        </span>
      </div>

      {view === 'sign-in' && (
        <SignInForm
          onForgotPassword={() => setView('forgot-password')}
          onSignUp={() => setView('sign-up')}
        />
      )}
      {view === 'sign-up' && <SignUpForm onSignIn={() => setView('sign-in')} />}
      {view === 'forgot-password' && (
        <ForgotPasswordForm onBack={() => setView('sign-in')} />
      )}
    </div>
  );
}
